export default __webpack_public_path__ + "terrain-map-800-3e2c6ffba2b1c8eb550de8eafb96d723.webp";